import { Button, Grid, MenuItem, Typography, useMediaQuery } from "@mui/material"
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material"
import { useState } from "react";
import { StyledMenu } from "components/Styled";

/**
 * Component that renders a header at the beginning of the category, subcategory and product modules
 */
export const HeaderSection = ({ headerTitle, buttonAction, buttonTitle, buttonDisabled }) => {
  const mdMQ = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <Grid container spacing={0} sx={{ padding: "10px 0px 20px 0px" }} >
      <Grid item xs={12} md={6}>
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: 17 }}> {headerTitle} </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Button
          variant="contained"
          size="small"
          sx={{ width: mdMQ ? "auto" : "100%", float: "right" }}
          onClick={buttonAction}
          disabled={buttonDisabled} >
          {buttonTitle}
        </Button>
      </Grid>
    </Grid >
  )
}

/**
 * Component that renders a header at the beginning of the category, subcategory and product modules with multiples buttons
 */
export const HeaderSectionMultiButton = ({ headerTitle, disabled, buttons }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => { setAnchorEl(event.currentTarget); };
  const handleClose = () => { setAnchorEl(null); };

  return (
    <Grid container spacing={0} sx={{ padding: "10px 0px 20px 0px" }} >
      <Grid item xs={12} sm={6}>
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: 17 }}> {headerTitle} </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Button
          sx={{ float: "right" }}
          id="demo-hsmb-button"
          aria-controls={open ? 'demo-hsmb-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          size="small"
          disabled={disabled}
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Agregar
        </Button>
      </Grid>
      <StyledMenu
        id={`demo-hsmb-menu`}
        MenuListProps={{ 'aria-labelledby': `demo-hsmb-button` }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose} >
        {buttons.map((button, index) => (
          <MenuItem key={index} onClick={() => { button.action(button.refAction); handleClose(); }} disableRipple> {button.icon} {button.title} </MenuItem>
        ))}
      </StyledMenu>
    </Grid >
  )
}